<template>
  <div>
    <b-dropdown
      ref="dropdown"
      variant="link"
      dropleft
      toggle-class="bg-transparent p-0 pr-md-0"
      no-caret
      menu-class="tooltipShadow"
    >
      <template #button-content>
        <svg-icon name="more-vertical" class="fill-icon" size="24"></svg-icon>
      </template>
      <div v-if="!isGroupSettings" class="preview-list" menu-class="p-0 m-0">
        <b-dropdown-item @click.prevent.stop="disableUser()">
          <svg-icon class="fill-icon mr-2" name="trash"></svg-icon>
          {{ $t('button.delete.label') }}
        </b-dropdown-item>
        <div class="preview-item dropdown-item dropdownButton" @click.prevent.stop="changeView()">
          <span class="preview-icon">
            <svg-icon v-show="!isGroupSettings" class="fill-icon mr-2" name="user"></svg-icon>
            <svg-icon
              v-show="isGroupSettings"
              class="fill-icon mr-2"
              name="chevron-left"
            ></svg-icon>
          </span>
          <div class="preview-item-content">
            <p class="preview-subject ellipsis mb-0">
              {{ $t('users.changeRole') }}
            </p>
          </div>
          <span class="preview-icon">
            <svg-icon class="fill-icon ml-2" name="chevron-right"></svg-icon>
          </span>
        </div>
      </div>
      <div v-else class="preview-list">
        <div class="preview-item dropdown-item dropdownButton" @click.prevent.stop="changeView()">
          <span class="preview-icon">
            <svg-icon v-show="!isGroupSettings" class="fill-icon mr-2" name="user"></svg-icon>
            <svg-icon
              v-show="isGroupSettings"
              class="fill-icon mr-2"
              name="chevron-left"
            ></svg-icon>
          </span>
          <span class="preview-subject ellipsis mb-0 text-muted pl-1">
            {{ $t('users.changeRole') }}
          </span>
        </div>
        <b-dropdown-item
          v-for="group in groupOptions"
          :key="group.value"
          class="preview-item space-between pl-4"
          @click="changeGroup(group.value)"
        >
          {{ group.text }}
          <svg-icon
            v-show="isCurrentGroup(group.value)"
            class="fill-icon ml-2"
            name="check"
          ></svg-icon>
        </b-dropdown-item>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'UserActionDropDown',
  props: {
    group: {
      required: true,
      type: String,
    },
    email: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      isGroupSettings: false,
      groupOptions: [
        {
          value: 'OEE_PM',
          text: this.$t('roles.OEE_PM'),
        },
        {
          value: 'OEE_USER',
          text: this.$t('roles.OEE_USER'),
        },
      ],
    };
  },
  computed: {
    groupText() {
      return this.group == 'OEE_PM' ? this.$t('roles.OEE_PM') : this.$t('roles.OEE_USER');
    },
  },
  methods: {
    disableUser() {
      this.$emit('disableUser', this.email);
    },
    changeView() {
      this.isGroupSettings = !this.isGroupSettings;
      console.log(this.isGroupSettings);
    },
    changeGroup(group) {
      this.isGroupSettings = !this.isGroupSettings;
      this.$emit('groupChange', this.email, group);
    },
    isCurrentGroup(group) {
      return this.group == group;
    },
  },
};
</script>
<style lang="scss" scoped>
.dropdownButton {
  cursor: pointer;
}
</style>
